var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.$modal.context.componentName,
    {
      tag: "component",
      attrs: {
        name: "dialog",
        height: "auto",
        classes: ["vue-dialog", this.params.class],
        width: _vm.width,
        "shift-y": 0.3,
        adaptive: true,
        "focus-trap": true,
        clickToClose: _vm.clickToClose,
        transition: _vm.transition
      },
      on: {
        "before-open": _vm.beforeOpened,
        "before-close": _vm.beforeClosed,
        opened: function($event) {
          return _vm.$emit("opened", $event)
        },
        closed: function($event) {
          return _vm.$emit("closed", $event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "vue-dialog-content" },
        [
          _vm.params.title
            ? _c("div", {
                staticClass: "vue-dialog-content-title",
                domProps: { innerHTML: _vm._s(_vm.params.title || "") }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.params.component
            ? _c(
                _vm.params.component,
                _vm._b(
                  { tag: "component" },
                  "component",
                  _vm.params.props,
                  false
                )
              )
            : _c("div", {
                domProps: { innerHTML: _vm._s(_vm.params.text || "") }
              })
        ],
        1
      ),
      _vm._v(" "),
      _vm.buttons
        ? _c(
            "div",
            { staticClass: "vue-dialog-buttons" },
            _vm._l(_vm.buttons, function(button, index) {
              return _c(
                "button",
                {
                  key: index,
                  class: button.class || "vue-dialog-button",
                  style: _vm.buttonStyle,
                  attrs: { type: "button", tabindex: "0" },
                  domProps: { innerHTML: _vm._s(button.title) },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.click(index, $event)
                    }
                  }
                },
                [_vm._v(_vm._s(button.title))]
              )
            }),
            0
          )
        : _c("div", { staticClass: "vue-dialog-buttons-none" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }